import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
// Scrub OAuth credentials before mounting any app providers or third-party SDKs.
if (window.location.pathname === '/personal/planner/calendar/callback') {
  const params = new URLSearchParams(window.location.search);
  const input = {
    code: params.get('code'),
    state: params.get('state'),
    error: params.get('error'),
  };
  window.history.replaceState(null, '', window.location.pathname);
  const meta = document.createElement('meta');
  meta.name = 'referrer';
  meta.content = 'no-referrer';
  document.head.appendChild(meta);
  void import('./components/planner/PlannerCalendarCallback').then(
    ({ PlannerCalendarCallback }) => {
      root.render(
        <React.StrictMode>
          <PlannerCalendarCallback input={input} />
        </React.StrictMode>,
      );
    },
  );
} else {
  // The isolated OAuth callback must not load third-party fonts or SDKs.
  for (const origin of [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
  ]) {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    if (origin.includes('gstatic')) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }
  const font = document.createElement('link');
  font.rel = 'stylesheet';
  font.href =
    'https://fonts.googleapis.com/css2?family=Epilogue:ital,wght@0,100..900;1,100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Outfit:wght@100..900&family=Roboto:wght@400;500&family=SUSE+Mono:wght@100..800&display=swap';
  document.head.appendChild(font);
  void import('./App').then(({ App }) =>
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    ),
  );
}
